export default __webpack_public_path__ + "static/media/person.3ad8c373.png";